const DEFAULT_CONFIG_URL =
  "https://storage.googleapis.com/fb-webapp-jestle-prod-market/app-config.json";

export async function loadAppConfig() {
  if (localDemoRequested()) {
    return {
      demoMode: true,
      localArtifactBase: localArtifactBase(),
      marketReplayApiBase: "demo",
      projectId: "demo",
    };
  }
  const urls = uniqueUrls([
    import.meta.env.VITE_MARKET_CONFIG_URL,
    DEFAULT_CONFIG_URL,
    "/app-config.json",
  ]);
  const errors = [];
  for (const url of urls) {
    try {
      const response = await fetch(url, { cache: "no-store" });
      if (!response.ok) {
        throw new Error(`${url} returned ${response.status}`);
      }
      const text = await response.text();
      const config = parseConfigJson(text, url);
      validateConfig(config, url);
      return {
        ...config,
        marketReplayApiBase:
          import.meta.env.VITE_MARKET_API_BASE ||
          config.marketReplayApiBase ||
          "/api",
      };
    } catch (error) {
      errors.push(`${url}: ${error.message}`);
    }
  }
  console.error("Market app config load failed", errors);
  throw new Error("Market app configuration could not be loaded.");
}

function parseConfigJson(text, url) {
  const trimmed = text.trimStart();
  if (!trimmed || trimmed.startsWith("<")) {
    throw new Error(`${url} did not return JSON`);
  }
  try {
    return JSON.parse(text);
  } catch (error) {
    throw new Error(`${url} is not valid JSON: ${error.message}`);
  }
}

function validateConfig(config, url) {
  for (const key of ["apiKey", "appId", "authDomain", "projectId"]) {
    if (!config[key] || String(config[key]).startsWith("filled-by-")) {
      throw new Error(`${url} is missing Firebase ${key}`);
    }
  }
}

function uniqueUrls(urls) {
  const seen = new Set();
  return urls.filter((url) => {
    if (!url || seen.has(url)) {
      return false;
    }
    seen.add(url);
    return true;
  });
}

function localDemoRequested() {
  const host = window.location.hostname;
  const isLocal = host === "127.0.0.1" || host === "localhost";
  if (!isLocal) {
    return false;
  }
  const params = new URLSearchParams(window.location.search);
  return (
    params.get("demo") === "1" || import.meta.env.VITE_MARKET_DEMO === "1"
  );
}

function localArtifactBase() {
  const params = new URLSearchParams(window.location.search);
  const artifactBase = params.get("artifacts");
  if (artifactBase === "/tmp/market-replay/actual") {
    return "/actual";
  }
  return artifactBase || "/actual";
}
